module.exports = __webpack_public_path__ + "static/media/concept.b71d4101.svg";